import { Suspense, type ReactNode } from 'react'
import { Loader } from '../../shared/components/ui/Loader'

interface SuspenseWrapperProps {
  children: ReactNode
  fallback?: ReactNode
  text?: string
}

export const SuspenseWrapper = ({ 
  children, 
  fallback,
  text = "Loading..." 
}: SuspenseWrapperProps) => {
  const defaultFallback = (
    <div className="min-h-screen flex items-center justify-center">
      <Loader fullScreen text={text} />
    </div>
  )

  return (
    <Suspense fallback={fallback || defaultFallback}>
      {children}
    </Suspense>
  )
}

// Feature-specific suspense wrappers with custom loading messages
export const FeatureSuspense = ({ 
  children, 
  featureName 
}: { 
  children: ReactNode
  featureName: string 
}) => (
  <SuspenseWrapper text={`Loading ${featureName}...`}>
    {children}
  </SuspenseWrapper>
)

// Route-level suspense wrapper
export const RouteSuspense = ({ children }: { children: ReactNode }) => (
  <SuspenseWrapper text="Loading page...">
    {children}
  </SuspenseWrapper>
)